const Id = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 17.5H14.5V16C14.5 15.4033 14.2629 14.831 13.841 14.409C13.419 13.9871 12.8467 13.75 12.25 13.75H7.75C7.15326 13.75 6.58097 13.9871 6.15901 14.409C5.73705 14.831 5.5 15.4033 5.5 16V17.5H4V16C4 15.0054 4.39509 14.0516 5.09835 13.3483C5.80161 12.6451 6.75544 12.25 7.75 12.25H12.25C13.2446 12.25 14.1984 12.6451 14.9017 13.3483C15.6049 14.0516 16 15.0054 16 16V17.5ZM10 10.75C9.40905 10.75 8.82389 10.6336 8.27792 10.4075C7.73196 10.1813 7.23588 9.84984 6.81802 9.43198C6.40016 9.01412 6.06869 8.51804 5.84254 7.97208C5.6164 7.42611 5.5 6.84095 5.5 6.25C5.5 5.65905 5.6164 5.07389 5.84254 4.52792C6.06869 3.98196 6.40016 3.48588 6.81802 3.06802C7.23588 2.65016 7.73196 2.31869 8.27792 2.09254C8.82389 1.8664 9.40905 1.75 10 1.75C11.1935 1.75 12.3381 2.22411 13.182 3.06802C14.0259 3.91193 14.5 5.05653 14.5 6.25C14.5 7.44347 14.0259 8.58807 13.182 9.43198C12.3381 10.2759 11.1935 10.75 10 10.75ZM10 9.25C10.7956 9.25 11.5587 8.93393 12.1213 8.37132C12.6839 7.80871 13 7.04565 13 6.25C13 5.45435 12.6839 4.69129 12.1213 4.12868C11.5587 3.56607 10.7956 3.25 10 3.25C9.20435 3.25 8.44129 3.56607 7.87868 4.12868C7.31607 4.69129 7 5.45435 7 6.25C7 7.04565 7.31607 7.80871 7.87868 8.37132C8.44129 8.93393 9.20435 9.25 10 9.25Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default Id;
